/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_Col_InterviewsInputs */

const en_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviews`)
};

const de_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräche`)
};

const fr_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretiens`)
};

const es_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrevistas`)
};

const it_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloqui`)
};

const nl_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekken`)
};

const pl_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowy`)
};

const fi_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelut`)
};

const da_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtaler`)
};

const sv_analytics_resume_perf_col_interviews = /** @type {(inputs: Analytics_Resume_Perf_Col_InterviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuer`)
};

/**
* | output |
* | --- |
* | "Interviews" |
*
* @param {Analytics_Resume_Perf_Col_InterviewsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_col_interviews = /** @type {((inputs?: Analytics_Resume_Perf_Col_InterviewsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_Col_InterviewsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_col_interviews(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_col_interviews(inputs)
	if (locale === "es") return es_analytics_resume_perf_col_interviews(inputs)
	if (locale === "it") return it_analytics_resume_perf_col_interviews(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_col_interviews(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_col_interviews(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_col_interviews(inputs)
	if (locale === "da") return da_analytics_resume_perf_col_interviews(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_col_interviews(inputs)
	return en_analytics_resume_perf_col_interviews(inputs)
});